import React, {
  useEffect,
  useState,
  useContext,
  useCallback,
  useLayoutEffect,
  useMemo,
  useRef,
} from 'react';
import {
  ActivityIndicator,
  BackHandler,
  Linking,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  ScrollView,
  Pressable,
  useWindowDimensions,
  Animated,
} from 'react-native';
import { AppAlert } from '../../services/AppAlert';
import SecureImage from '../../components/Reusables/SecureImage';
import {
  useTheme,
  useThemeColors,
  GTFonts,
  getIconContainerStyle,
  withOpacity,
  getSizeClass,
} from '../../theme';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { AuthContext } from '../../Context/AuthContext';
import { ModalContext } from '../../Context/modalContext';
import AsyncStorage from '@react-native-async-storage/async-storage';
import ErrorContext from '../../Context/ErrorContext';
import { useFocusEffect } from '@react-navigation/native';
import { useDispatch } from 'react-redux';
import {
  fs,
  s,
  v,
  iconSize,
  borderWidth,
  dumpTokens,
  forceHttps,
} from '../../utils/libs';
import { getApiMessage } from '../../utils/apiError';
import {
  getLocationEpoch,
  isCurrentLocationEpoch,
} from '../../utils/locationEpoch';
import {
  addProductsNames,
  addupdateProducts,
  clearAllProducts,
  clearCategories,
  clearSubCategories,
  clearProductsNames,
  clearProductsBySubCategory,
  resetSearchProducts,
  clearSearchedProductsFromScanner,
  selectProductDocs,
} from '../../redux/productSlice';
import { getProducts, getProductsNames } from '../../api/products';
import { getMpesaConfigurationInformation } from '../../api/mpesa';
import {
  clearFetchedMpesaConfig,
  setFetchedMpesaConfig,
} from '../../redux/mpesaConfig';
import { logoutAction } from '../../redux/Store';
import CustomBottomSheet from '../../components/Reusables/bottomSheet/CustomBottomSheet';
import LucideIcon from '../../components/Reusables/LucideIcon';
import QuickActionSegments, {
  buildQuickActionSegments,
} from '../../components/home/QuickActionSegments';
import { addSettings } from '../../redux/SettingsSlice';
import { getRemoteAppVersion, getSettings } from '../../api/settings';
import { prefetchLocationAssignableStaff } from '../../api/employees';
import { ClearCart, clearCartOrderData } from '../../redux/cartSlice';
import { clearCheckout } from '../../redux/checkoutSlice';
import {
  clearCompletedOrders,
  clearPendingOrders,
  clearPartialOrders,
  clearFilteredCompletedOrder,
  clearFilteredPendingOrder,
  clearFilteredPartialOrder,
  addCompletedOrder,
  addPartialOrder,
  addpending,
  setCloudCustomerSummaries,
  clearCloudCustomerSummaries,
} from '../../redux/OrdersSlice';
import { clearOrderDetails } from '../../redux/orderDetailsSlice';
import { clearPartialPaymentsDetails } from '../../redux/partialPaymentsSlice';
import DeviceInfo, { isTablet } from 'react-native-device-info';
import { PRODUCT_LIMIT } from '../../CONSTANTS';
import { clearEmployeeAndBusinessInfo } from '../../redux/AuthSlice';
import { useAppSelector } from '../../redux/helper';
import { selectValidCurrentLocation } from '../../redux/locationSlice';
import { RootState } from '../../redux/types';
import useLocation from '../../hooks/useLocation';
import useFetchSubCategories from '../../hooks/useFetchSubCategories';
import useOwnerHomeActivationBootstrap from '../../hooks/useOwnerHomeActivationBootstrap';
import { requestOpenLocationPicker } from '../../redux/uiSlice';
import OwnerGuidanceSlot from './components/OwnerGuidanceSlot';
import OwnerActivationTrackerContainer from './components/OwnerActivationTrackerContainer';
import OwnerActivationCelebrationController from './components/OwnerActivationCelebrationController';
import WizardHomeCelebrationController from './components/WizardHomeCelebrationController';
import { isEmployeeOwnerRole } from '../../utils/roles';
import { RootStackParamList } from '../../navigation/AppStack';
import {
  getCompletedOrders,
  getEmployeeRecentOrders,
  getPartialOrders,
  getPendingOrders,
} from '../../api/orders';
import { getRecentOrders } from '../../api/backofficeOrders';
import { getCustomerOrderSummaries } from '../../api/orders';
import Feather from '@react-native-vector-icons/feather/static';
import MaterialCommunityIcons from '@react-native-vector-icons/material-design-icons/static';
import Foundation from '@react-native-vector-icons/foundation/static';
import MaterialIcons from '@react-native-vector-icons/material-icons/static';
import Ionicons from '@react-native-vector-icons/ionicons/static';
import FontAwesome from '@react-native-vector-icons/fontawesome6/static';
import {
  selectQuickActionOrder,
  selectEnabledQuickActions,
  selectIconStyle,
  selectQuickActionColorMode,
} from '../../redux/SettingsSlice';
import { addSingleSetting } from '../../redux/SettingsSlice';
import useBackofficeOwnerAuth from '../../hooks/useBackofficeOwnerAuth';
import useBackofficeAxios from '../../hooks/useBackofficeAxios';
import { getExpenseTypes } from '../../api/backofficeExpenses';
import {
  setExpenseTypes,
  setExpenseTypesError,
  setExpenseTypesLoading,
} from '../../redux/backoffice/expensesSlice';
import {
  addRecentTransactionsPage,
  clearRecentTransactions,
  selectRecentTransactionsState,
  setRecentTransactions,
  setRecentTransactionsError,
  setRecentTransactionsLoading,
} from '../../redux/backoffice/recentTransactionsSlice';
import {
  addEmployeeRecentTransactionsPage,
  clearEmployeeRecentTransactions,
  selectEmployeeRecentTransactionsState,
  setEmployeeRecentTransactions,
  setEmployeeRecentTransactionsError,
  setEmployeeRecentTransactionsLoading,
} from '../../redux/backoffice/employeeRecentTransactionsSlice';
import { useNavigation as useNavigationContext } from '../../Context/NavigationContext';
import { toOrderDetailsData } from '../../utils/orderDetailsData';
import RecentTransactionsSection from '../../components/home/RecentTransactionsSection';
import FastImage from '@d11/react-native-fast-image';

type HomeScreenNavigationProp = NativeStackNavigationProp<RootStackParamList>;

interface HomeScreenProps {
  navigation: HomeScreenNavigationProp;
}

type ShopMeta = { title: string; subtitle: string; icon: string };

const candidates: Array<{ matchers: string[]; meta: ShopMeta }> = [
  {
    matchers: ['pharmacy', 'chemist', 'drug'],
    meta: { title: 'PHARMACY', subtitle: 'Sell Medicine', icon: 'capsules' },
  },
  {
    matchers: ['hardware', 'tools'],
    meta: {
      title: 'HARDWARE',
      subtitle: 'Sell Tools',
      icon: 'screwdriver-wrench',
    },
  },
  {
    matchers: ['bakery', 'baker'],
    meta: {
      title: 'BAKERY',
      subtitle: 'Sell Bread & Pastries',
      icon: 'bread-slice',
    },
  },
  {
    matchers: ['butchery', 'butcher'],
    meta: { title: 'BUTCHERY', subtitle: 'Sell Meat', icon: 'drumstick-bite' },
  },
  {
    matchers: ['phone accessory', 'phone accessories'],
    meta: {
      title: 'PHONE SHOP',
      subtitle: 'Sell Accessories & Parts',
      icon: 'mobile-screen',
    },
  },
  {
    matchers: ['bar', 'pub', 'club'],
    meta: {
      title: 'BAR',
      subtitle: 'Sell Drinks',
      icon: 'martini-glass-citrus',
    },
  },
  {
    matchers: ['wines', 'spirit', 'liquor'],
    meta: {
      title: 'WINES & SPIRITS',
      subtitle: 'Sell Liquor',
      icon: 'wine-glass',
    },
  },
  {
    matchers: ['hotel', 'restaurant', 'food'],
    meta: {
      title: 'RESTAURANT',
      subtitle: 'Sell Food & Drinks',
      icon: 'utensils',
    },
  },
  {
    matchers: ['coffee', 'cafe', 'coffe', 'coffee shop'],
    meta: {
      title: 'COFFEE SHOP',
      subtitle: 'Sell Drinks & Snacks',
      icon: 'mug-saucer',
    },
  },
  {
    matchers: ['book'],
    meta: { title: 'BOOKSHOP', subtitle: 'Sell Books', icon: 'book' },
  },
  {
    matchers: ['boutique'],
    meta: { title: 'BOUTIQUE', subtitle: 'Sell Apparel', icon: 'shirt' },
  },
  {
    matchers: ['beauty', 'cosmetic', 'salon'],
    meta: {
      title: 'BEAUTY SHOP',
      subtitle: 'Sell Cosmetics',
      icon: 'wand-magic-sparkles',
    },
  },
  {
    matchers: ['electronics', 'electric'],
    meta: { title: 'ELECTRONICS', subtitle: 'Sell Electronics', icon: 'tv' },
  },
  {
    matchers: ['auto', 'spare'],
    meta: { title: 'AUTO SPARES', subtitle: 'Sell Spares', icon: 'car' },
  },
  {
    matchers: ['grocery', 'groceries'],
    meta: {
      title: 'GROCERY',
      subtitle: 'Sell Groceries',
      icon: 'basket-shopping',
    },
  },
  {
    matchers: ['supermarket'],
    meta: {
      title: 'SUPERMARKET',
      subtitle: 'Sell Products',
      icon: 'cart-shopping',
    },
  },
  {
    matchers: ['jewel'],
    meta: { title: 'JEWELRY', subtitle: 'Sell Jewelry', icon: 'gem' },
  },
  {
    matchers: ['gift'],
    meta: { title: 'GIFT SHOP', subtitle: 'Sell Gifts', icon: 'gift' },
  },
  {
    matchers: ['kiosk'],
    meta: { title: 'KIOSK', subtitle: 'Sell Items', icon: 'store' },
  },
  {
    matchers: ['agrovet'],
    meta: {
      title: 'AGROVET',
      subtitle: 'Feed & Vet Supplies',
      icon: 'paw',
    },
  },
  {
    matchers: ['cereals', 'grain'],
    meta: {
      title: 'CEREALS & GRAINS',
      subtitle: 'Sell Grains & Pulses',
      icon: 'seedling',
    },
  },
  {
    matchers: ['mini mart', 'minimart'],
    meta: {
      title: 'MINI MART',
      subtitle: 'Sell Everyday Items',
      icon: 'basket-shopping',
    },
  },
  {
    matchers: ['fruit', 'vegetable'],
    meta: {
      title: 'PRODUCE',
      subtitle: 'Sell Fruits & Vegetables',
      icon: 'leaf',
    },
  },
  {
    matchers: ['milk atm'],
    meta: {
      title: 'MILK ATM',
      subtitle: 'Sell Milk & Dairy',
      icon: 'tint',
    },
  },
  {
    matchers: ['stationery', 'printing'],
    meta: {
      title: 'STATIONERY',
      subtitle: 'Sell Office & School',
      icon: 'pen',
    },
  },
  {
    matchers: ['furniture', 'fitting'],
    meta: {
      title: 'FURNITURE',
      subtitle: 'Sell Furniture',
      icon: 'couch',
    },
  },
  {
    matchers: ['home & kitchen', 'home kitchen'],
    meta: {
      title: 'HOME & KITCHEN',
      subtitle: 'Sell Household',
      icon: 'home',
    },
  },
  {
    matchers: ['general shop', 'general', 'shop'],
    meta: { title: 'SHOP', subtitle: 'Sell Products', icon: 'shop' },
  },
  {
    matchers: ['store'],
    meta: { title: 'STORE', subtitle: 'Sell Products', icon: 'store' },
  },
];

// Animated card component for hover effects
const AnimatedCard = ({
  children,
  onPress,
  style,
  disabled,
  variant = 'primary',
}: {
  children: React.ReactNode;
  onPress: () => void;
  style?: any;
  disabled?: boolean;
  variant?: 'primary' | 'secondary';
}) => {
  const { theme } = useTheme();
  const colors = useThemeColors();
  const cardHoverStyles = useMemo(
    () => createCardHoverStyles(colors),
    [colors],
  );
  const [isHovered, setIsHovered] = useState(false);
  const [isPressed, setIsPressed] = useState(false);
  const translateY = useRef(new Animated.Value(0)).current;
  const scale = useRef(new Animated.Value(1)).current;

  useEffect(() => {
    if (isHovered && !disabled) {
      Animated.parallel([
        Animated.spring(translateY, {
          toValue: -2,
          useNativeDriver: true,
          tension: 300,
          friction: 20,
        }),
        Animated.spring(scale, {
          toValue: 1.005,
          useNativeDriver: true,
          tension: 300,
          friction: 20,
        }),
      ]).start();
    } else {
      Animated.parallel([
        Animated.spring(translateY, {
          toValue: 0,
          useNativeDriver: true,
          tension: 300,
          friction: 20,
        }),
        Animated.spring(scale, {
          toValue: 1,
          useNativeDriver: true,
          tension: 300,
          friction: 20,
        }),
      ]).start();
    }
  }, [isHovered, disabled]);

  const handlePressIn = () => {
    setIsPressed(true);
    Animated.spring(scale, {
      toValue: 0.99,
      useNativeDriver: true,
      tension: 400,
      friction: 25,
    }).start();
  };

  const handlePressOut = () => {
    setIsPressed(false);
    Animated.spring(scale, {
      toValue: isHovered ? 1.005 : 1,
      useNativeDriver: true,
      tension: 300,
      friction: 20,
    }).start();
  };

  return (
    <Pressable
      onPress={onPress}
      onPressIn={handlePressIn}
      onPressOut={handlePressOut}
      onHoverIn={() => setIsHovered(true)}
      onHoverOut={() => setIsHovered(false)}
      disabled={disabled}
      style={[style, isHovered && !disabled && cardHoverStyles.cardHovered]}>
      <Animated.View style={[{ transform: [{ translateY }, { scale }] }]}>
        {children}
      </Animated.View>
    </Pressable>
  );
};

// Hover styles for cards - will be created with theme colors in component
const createCardHoverStyles = (colors: any) =>
  StyleSheet.create({
    cardHovered: {
      boxShadow: `0px ${v(8)}px ${s(16)}px rgba(0, 0, 0, 0.1)`,
    } as any,
  });

// Quick action button with hover effect
const QuickActionButton = ({
  action,
  iconStyles,
  isLocationSwitching,
  styles,
}: {
  action: any;
  iconStyles: any;
  isLocationSwitching: boolean;
  styles: any;
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Pressable
      onPress={action.onPress}
      onHoverIn={() => setIsHovered(true)}
      onHoverOut={() => setIsHovered(false)}
      disabled={isLocationSwitching}
      style={[
        styles.quickActionItem,
        isLocationSwitching && { opacity: 0.5 },
        isHovered && styles.quickActionItemHovered,
      ]}>
      <View
        style={[
          styles.quickActionIcon,
          {
            backgroundColor: iconStyles.backgroundColor,
            borderColor: iconStyles.borderColor,
            borderWidth: borderWidth(2),
          },
          isHovered && {
            transform: [{ scale: 1.05 }],
          },
        ]}>
        {action.renderIcon(iconStyles.iconColor)}
      </View>
      <Text
        style={[
          styles.quickActionText,
          isHovered && styles.quickActionTextHovered,
        ]}>
        {action.key === 'aiAssistant' ? 'Rafiki AI' : action.label}
      </Text>
    </Pressable>
  );
};

const HomeScreen = ({ navigation }: HomeScreenProps) => {
  const { width, height } = useWindowDimensions();
  const { autoLoginOwner } = useBackofficeOwnerAuth();
  const currentLocation = useAppSelector(selectValidCurrentLocation);
  const { auth, setAuth } = useContext(AuthContext);
  const dispatch = useDispatch();
  const owner = useAppSelector(s => s.backofficeOwnerAuth);
  const { theme } = useTheme();
  const colors = useThemeColors();
  const styles = useMemo(() => createStyles(theme, width), [theme, width]);
  const [appVersion, setAppVersion] = useState('');

  useEffect(() => {
    const v = String(DeviceInfo.getVersion() || '').trim();
    if (v) {
      setAppVersion(v.replace('-prod', '').trim());
    }
  }, []);

  const business = useAppSelector(
    (state: RootState) => state.auth.inApp.account.businessInfo,
  );
  const employeedata = useAppSelector(
    (state: RootState) => state.auth.inApp.account.employeeInfo,
  );
  const manualServiceDisplayOverride = useAppSelector(
    (state: RootState) => state.settings.settings.serviceDisplayManualOverride,
  );
  const quickActionOrder = useAppSelector(selectQuickActionOrder);
  const enabledQuickActions = useAppSelector(selectEnabledQuickActions);
  const iconStyle = useAppSelector(selectIconStyle);
  const quickActionColorMode = useAppSelector(selectQuickActionColorMode);

  // Auto-enable Live Orders for eatery businesses unless manually overridden
  useEffect(() => {
    const rawType = (
      (business as any)?.bp_business_type ||
      (business as any)?.type ||
      ''
    )
      .toString()
      .trim()
      .toLowerCase();
    const isEatery = [
      'hotel',
      'restaurant',
      'bakery',
      'bar',
      'cafe',
      'coffee',
      'pub',
      'club',
    ].some(keyword => rawType.includes(keyword));
    if (manualServiceDisplayOverride) return;
    const hasServiceDisplay = enabledQuickActions?.includes('serviceDisplay');
    if (isEatery && !hasServiceDisplay) {
      dispatch(
        addSingleSetting({
          enabledQuickActions: [
            ...(enabledQuickActions || []),
            'serviceDisplay',
          ],
        }),
      );
    } else if (!isEatery && hasServiceDisplay) {
      dispatch(
        addSingleSetting({
          enabledQuickActions: (enabledQuickActions || []).filter(
            k => k !== 'serviceDisplay',
          ),
        }),
      );
    }
  }, [
    business,
    currentLocation,
    manualServiceDisplayOverride,
    enabledQuickActions,
    dispatch,
  ]);

  const { bottomSheetHomeModalRef } = useContext(ModalContext);
  const [selectedQuickSegment, setSelectedQuickSegment] = useState(0);
  const axiosprivate = useAxiosPrivate();
  const axiosBackoffice = useBackofficeAxios();
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const { handleError } = useContext(ErrorContext);
  const { isAdmin, fetchLocations, isLocationSwitching } = useLocation();
  const productDocs = useAppSelector(selectProductDocs);
  const { setOrderDetailsData } = useNavigationContext();

  const recentTransactionsState = useAppSelector(selectRecentTransactionsState);
  const employeeRecentTransactionsState = useAppSelector(
    selectEmployeeRecentTransactionsState,
  );
  useOwnerHomeActivationBootstrap({
    productCount: productDocs.length,
    productsLoaded:
      !isLocationSwitching &&
      !recentTransactionsState.loading &&
      recentTransactionsState.lastFetchedAt !== null,
    recentTransactionDocs: recentTransactionsState.recent.docs || [],
    transactionsLoaded:
      !isLocationSwitching &&
      !recentTransactionsState.loading &&
      recentTransactionsState.lastFetchedAt !== null,
  });
  const handleOpenLocationPicker = useCallback(
    () => dispatch(requestOpenLocationPicker()),
    [dispatch],
  );
  const todayDashData = useAppSelector(
    (s: RootState) => s.backofficeDashboard.todayDashboardData,
  );
  const todayDashLoading = useAppSelector(
    (s: RootState) => s.backofficeDashboard.todayDashboardLoading,
  );
  const currency = useMemo(
    () => currentLocation?.bp_location_settings?.bp_location_currency || 'KES',
    [currentLocation?.bp_location_settings?.bp_location_currency],
  );

  const showservicedisplay = useMemo(() => {
    if (isAdmin) {
      return false;
    }
    const role = employeedata?.bp_employee_role?.toLowerCase?.() || '';
    const normalRoles = ['cashier', 'manager', 'owner', 'supervisor'];
    if (normalRoles.some(normalRole => role.includes(normalRole))) {
      return false;
    }
    const barRoles = ['bartender', 'mixologist', 'barista', 'sommelier'];
    const kitchenRoles = [
      'chef',
      'cook',
      'baker',
      'butcher',
      'kitchen',
      'sous chef',
      'pastry chef',
    ];
    const isBarRole = barRoles.some(barRole => role.includes(barRole));
    const isKitchenRole = kitchenRoles.some(kitchenRole =>
      role.includes(kitchenRole),
    );
    if (isBarRole || isKitchenRole) {
      return true;
    }
    const rawType = (
      (business as any)?.bp_business_type ||
      (business as any)?.type ||
      ''
    ).trim();
    const type = rawType.toLowerCase();
    const isKitchen =
      type.includes('hotel') ||
      type.includes('restaurant') ||
      type.includes('bakery') ||
      type.includes('coffee') ||
      type.includes('cafe');
    const isBar =
      type.includes('bar') || type.includes('pub') || type.includes('club');
    if (isKitchen || isBar) {
      return true;
    }
    const isServiceRole =
      role === 'baker' ||
      role === 'chef' ||
      role === 'butcher' ||
      role === 'bartender' ||
      role === 'mixologist';
    return isServiceRole;
  }, [isAdmin, employeedata?.bp_employee_role, business]);

  const orderDisplayMeta = useMemo(() => {
    return {
      label: 'Live Orders',
      icon: 'receipt-outline',
    } as const;
  }, []);

  const shopActionMeta = useMemo(() => {
    const rawType = (
      (business as any)?.bp_business_type ||
      (business as any)?.type ||
      ''
    )
      .toString()
      .trim()
      .toLowerCase();
    const found = candidates.find(entry =>
      entry.matchers.some(keyword => rawType.includes(keyword)),
    );
    return (
      found?.meta || { title: 'SHOP', subtitle: 'Sell Products', icon: 'shop' }
    );
  }, [business]);

  useEffect(() => {
    if (isAdmin) {
      void autoLoginOwner();
    }
  }, [isAdmin, autoLoginOwner]);

  const handleBackOfficePress = useCallback(async () => {
    try {
      navigation.navigate('BackOffice');
      await autoLoginOwner();
    } catch (e: any) {
      handleError(getApiMessage(e, 'Owner login error'), 'error', true);
    }
  }, [owner?.accessToken, autoLoginOwner, navigation, handleError]);

  const handleBackOfficeOrdersPress = useCallback(async () => {
    try {
      await autoLoginOwner();
      navigation.navigate('BackOffice', { screen: 'Orders' });
    } catch (e: any) {
      handleError(getApiMessage(e, 'Owner login error'), 'error', true);
    }
  }, [autoLoginOwner, navigation, handleError]);

  const handleOrdersPress = useCallback(
    () => navigation.navigate('Orders'),
    [navigation],
  );

  const normalizeRecentPaginated = useCallback((payload: any, page: number) => {
    return {
      docs: Array.isArray(payload?.docs)
        ? payload.docs
        : Array.isArray(payload?.data)
          ? payload.data
          : [],
      hasNextPage: Boolean(
        payload?.hasNextPage ??
          (payload?.page ?? page) < (payload?.totalPages ?? 0),
      ),
      hasPrevPage: Boolean(payload?.hasPrevPage ?? (payload?.page ?? page) > 1),
      limit: Number(payload?.limit ?? payload?.perPage ?? 50),
      nextPage: Number(
        payload?.nextPage ??
          ((payload?.page ?? page) < (payload?.totalPages ?? 0)
            ? (payload?.page ?? page) + 1
            : (payload?.page ?? page)),
      ),
      page: Number(payload?.page ?? page),
      perPage: Number(payload?.perPage ?? payload?.limit ?? 50),
      totalDocs: Number(payload?.totalDocs ?? payload?.total ?? 0),
      totalPages: Number(
        payload?.totalPages ??
          Math.max(
            1,
            Math.ceil(
              Number(payload?.totalDocs ?? payload?.total ?? 0) /
                Number(payload?.perPage ?? payload?.limit ?? 50),
            ),
          ),
      ),
    };
  }, []);

  const recentRequestSeqRef = useRef(0);
  const fetchOwnerRecentTransactions = useCallback(
    async (
      page: number = 1,
      opts?: { silent?: boolean; append?: boolean },
    ): Promise<boolean> => {
      if (!isAdmin || !owner?.accessToken) return false;
      const ownerId = String((employeedata as any)?.bp_owner_id || '');
      if (!ownerId) return false;
      const seq = ++recentRequestSeqRef.current;
      try {
        if (!opts?.silent) {
          dispatch(setRecentTransactionsLoading(true));
          dispatch(setRecentTransactionsError(null));
        }
        const response = await getRecentOrders(
          axiosBackoffice as any,
          ownerId,
          page,
          50,
          { accessToken: owner.accessToken },
        );
        if (seq !== recentRequestSeqRef.current) return false;
        if (response?.status === 200) {
          const payload = normalizeRecentPaginated(
            response?.data?.data ?? response?.data,
            page,
          );
          if (opts?.append) {
            dispatch(addRecentTransactionsPage(payload as any));
          } else {
            dispatch(setRecentTransactions(payload as any));
          }
          return true;
        }
        if (!opts?.silent) {
          dispatch(
            setRecentTransactionsError(
              String(
                response?.data?.message || 'Failed to fetch recent orders',
              ),
            ),
          );
        }
        return false;
      } catch (e: any) {
        if (seq !== recentRequestSeqRef.current) return false;
        if (!opts?.silent) {
          dispatch(
            setRecentTransactionsError(
              e?.message || 'Failed to fetch recent transactions',
            ),
          );
        }
        return false;
      } finally {
        if (!opts?.silent && seq === recentRequestSeqRef.current) {
          dispatch(setRecentTransactionsLoading(false));
        }
      }
    },
    [
      isAdmin,
      owner?.accessToken,
      employeedata,
      dispatch,
      axiosBackoffice,
      normalizeRecentPaginated,
    ],
  );

  const employeeRecentRequestSeqRef = useRef(0);
  const fetchEmployeeRecentTransactions = useCallback(
    async (
      page: number = 1,
      opts?: { silent?: boolean; append?: boolean },
    ): Promise<boolean> => {
      if (isAdmin || !auth?.accessToken) return false;
      const seq = ++employeeRecentRequestSeqRef.current;
      try {
        if (!opts?.silent) {
          dispatch(setEmployeeRecentTransactionsLoading(true));
          dispatch(setEmployeeRecentTransactionsError(null));
        }
        const response = await getEmployeeRecentOrders(
          axiosprivate as any,
          page,
          50,
          { accessToken: auth.accessToken },
        );
        if (seq !== employeeRecentRequestSeqRef.current) return false;
        if (response?.status === 200) {
          const payload = normalizeRecentPaginated(
            response?.data?.data ?? response?.data,
            page,
          );
          if (opts?.append) {
            dispatch(addEmployeeRecentTransactionsPage(payload as any));
          } else {
            dispatch(setEmployeeRecentTransactions(payload as any));
          }
          return true;
        }
        if (!opts?.silent) {
          dispatch(
            setEmployeeRecentTransactionsError(
              String(
                response?.data?.message || 'Failed to fetch recent orders',
              ),
            ),
          );
        }
        return false;
      } catch (e: any) {
        if (seq !== employeeRecentRequestSeqRef.current) return false;
        if (!opts?.silent) {
          dispatch(
            setEmployeeRecentTransactionsError(
              e?.message || 'Failed to fetch recent transactions',
            ),
          );
        }
        return false;
      } finally {
        if (!opts?.silent && seq === employeeRecentRequestSeqRef.current) {
          dispatch(setEmployeeRecentTransactionsLoading(false));
        }
      }
    },
    [
      isAdmin,
      auth?.accessToken,
      dispatch,
      axiosprivate,
      normalizeRecentPaginated,
    ],
  );

  useEffect(() => {
    if (!isAdmin) {
      dispatch(clearRecentTransactions());
    }
  }, [isAdmin, dispatch]);

  useFocusEffect(
    useCallback(() => {
      if (!isAdmin || !owner?.accessToken) return;
      void fetchOwnerRecentTransactions(1);
    }, [
      isAdmin,
      owner?.accessToken,
      currentLocation?._id,
      fetchOwnerRecentTransactions,
    ]),
  );

  useEffect(() => {
    if (isAdmin || showservicedisplay || !auth?.accessToken) return;
    fetchEmployeeRecentTransactions(1);
  }, [
    isAdmin,
    showservicedisplay,
    currentLocation?._id,
    auth?.accessToken,
    fetchEmployeeRecentTransactions,
  ]);

  useEffect(() => {
    if (isAdmin || showservicedisplay) {
      dispatch(clearEmployeeRecentTransactions());
    }
  }, [isAdmin, showservicedisplay, dispatch]);

  const handleOpenRecentTransaction = useCallback(
    (order: any) => {
      if (!order?.bp_order_id) return;
      navigation.navigate('OrderDetails');
      setTimeout(() => {
        setOrderDetailsData(toOrderDetailsData(order));
      });
    },
    [navigation, setOrderDetailsData],
  );

  const handleLoadMoreOwnerRecent = useCallback(() => {
    const { recent, loading } = recentTransactionsState;
    if (recent.hasNextPage && !loading) {
      void fetchOwnerRecentTransactions(recent.nextPage, { append: true });
    }
  }, [recentTransactionsState, fetchOwnerRecentTransactions]);

  const handleLoadMoreEmployeeRecent = useCallback(() => {
    const { recent, loading } = employeeRecentTransactionsState;
    if (recent.hasNextPage && !loading) {
      void fetchEmployeeRecentTransactions(recent.nextPage, { append: true });
    }
  }, [employeeRecentTransactionsState, fetchEmployeeRecentTransactions]);

  const scrollViewRef = useRef<ScrollView | null>(null);

  const getTimeBasedGreeting = () => {
    const hour = new Date().getHours();
    // Business-friendly: morning (00-11), afternoon (12-17), evening (18-23)
    if (hour < 12) return 'Good Morning';
    if (hour < 18) return 'Good Afternoon';
    return 'Good Evening';
  };

  useEffect(() => {
    const init = async () => {
      await fetchLocations();
    };
    init();
  }, []);

  const getAllproducts = useCallback(
    async (currentpage: number) => {
      const epoch = getLocationEpoch();
      try {
        const response = await getProducts(
          axiosprivate,
          currentpage,
          PRODUCT_LIMIT,
          auth,
        );
        if (!isCurrentLocationEpoch(epoch)) return;
        if (response?.data?.status === 200) {
          dispatch(addupdateProducts(response?.data.data));
        } else {
          handleError(response.data.message, 'error', true);
        }
      } catch (error: any) {
        if (!isCurrentLocationEpoch(epoch)) return;
        handleError(getApiMessage(error), 'error', true);
      }
    },
    [auth],
  );

  const getAllproductsNames = useCallback(async () => {
    const epoch = getLocationEpoch();
    try {
      const response = await getProductsNames(axiosprivate, auth);
      if (!isCurrentLocationEpoch(epoch)) return;
      if (response?.data?.status === 200) {
        dispatch(addProductsNames(response?.data.data));
      } else {
        handleError(response.data.message, 'error', true);
      }
    } catch (error: any) {
      if (!isCurrentLocationEpoch(epoch)) return;
      handleError(getApiMessage(error), 'error', true);
    }
  }, [auth]);

  const fetchSubCategories = useFetchSubCategories();

  const prefetchAssignableStaffIfEnabled = useCallback(
    (enabled: boolean) => {
      if (!enabled || !currentLocation?._id || !auth?.accessToken) return;
      void prefetchLocationAssignableStaff(
        axiosprivate as any,
        auth,
        String(currentLocation._id),
      );
    },
    [axiosprivate, auth, auth?.accessToken, currentLocation?._id],
  );

  const getSettingsFn = async () => {
    if (!currentLocation?._id) return;
    const epoch = getLocationEpoch();
    try {
      const response = await getSettings(
        axiosprivate,
        auth,
        currentLocation._id,
      );
      if (!isCurrentLocationEpoch(epoch)) return;
      if (response.data.success) {
        const settings = response.data.data.bp_location_settings;
        const payload = {
          allow_partial_orders: settings.bp_location_allow_partial_orders,
          allow_staff_order_assignment:
            settings.bp_location_allow_staff_order_assignment,
          allow_sms_notification: settings.bp_location_allow_sms_notification,
          allow_email_notification:
            settings.bp_location_allow_email_notification,
        };
        dispatch(addSettings(payload));
        prefetchAssignableStaffIfEnabled(
          Boolean(settings.bp_location_allow_staff_order_assignment),
        );
      } else {
        handleError(response.data.message, 'error', true);
      }
    } catch (error: any) {
      if (!isCurrentLocationEpoch(epoch)) return;
      handleError(getApiMessage(error), 'error', true);
    }
  };

  const getCompletedAllOrders = async (currentpage: number) => {
    const epoch = getLocationEpoch();
    try {
      const response = await getCompletedOrders(
        axiosprivate,
        currentpage,
        auth,
      );
      if (!isCurrentLocationEpoch(epoch)) return;
      if (response.data.status === 200) {
        dispatch(addCompletedOrder(response.data.data));
      } else {
        handleError(response.data.message, 'error', true);
      }
    } catch (error: any) {
      if (!isCurrentLocationEpoch(epoch)) return;
      handleError(getApiMessage(error), 'error', true);
    }
  };

  const getPartialAllOrders = async (currentpage: number) => {
    const epoch = getLocationEpoch();
    try {
      const response = await getPartialOrders(axiosprivate, currentpage, auth);
      if (!isCurrentLocationEpoch(epoch)) return;
      if (response.data.status === 200) {
        dispatch(addPartialOrder(response.data.data));
      }
    } catch (error) {}
  };

  const getPendingAllOrders = async (currentpage: number) => {
    const epoch = getLocationEpoch();
    try {
      const response = await getPendingOrders(axiosprivate, currentpage, auth);
      if (!isCurrentLocationEpoch(epoch)) return;
      if (response.data.status === 200) {
        dispatch(addpending(response.data.data));
      } else {
        handleError(response.data.message, 'error', true);
      }
    } catch (error: any) {
      if (!isCurrentLocationEpoch(epoch)) return;
      handleError(getApiMessage(error), 'error', true);
    }
  };

  const clearAllData = () => {
    dispatch(clearAllProducts());
    dispatch(clearCategories());
    dispatch(clearSubCategories());
    dispatch(clearProductsNames());
    dispatch(clearProductsBySubCategory());
    dispatch(resetSearchProducts());
    dispatch(clearSearchedProductsFromScanner());
    dispatch(ClearCart());
    dispatch(clearCartOrderData());
    dispatch(clearCheckout());
    dispatch(clearCompletedOrders());
    dispatch(clearPendingOrders());
    dispatch(clearPartialOrders());
    dispatch(clearFilteredCompletedOrder());
    dispatch(clearFilteredPendingOrder());
    dispatch(clearFilteredPartialOrder());
    dispatch(clearOrderDetails());
    dispatch(clearPartialPaymentsDetails());
    dispatch(clearRecentTransactions());
    dispatch(clearCloudCustomerSummaries());
  };

  const getMpesaConfigFn = async () => {
    try {
      const response = await getMpesaConfigurationInformation(
        axiosprivate,
        auth,
      );
      if (response?.data?.status === 200) {
        dispatch(setFetchedMpesaConfig(response.data.data));
      } else if (response?.data?.status === 404) {
        // 200 with a 404 body: M-Pesa is not active at this location.
        dispatch(clearFetchedMpesaConfig());
      }
    } catch (error) {}
  };

  const getCriticalData = async () => {
    try {
      fetchSubCategories();
      getAllproductsNames();
      getAllproducts(1);
      getCompletedAllOrders(1);
      getPartialAllOrders(1);
      getPendingAllOrders(1);
      getMpesaConfigFn();
      prefetchAssignableStaffIfEnabled(
        Boolean(
          currentLocation?.bp_location_settings
            ?.bp_location_allow_staff_order_assignment,
        ),
      );
      if (currentLocation?._id && auth?.accessToken) {
        getCustomerOrderSummaries(
          axiosprivate as any,
          String(currentLocation._id),
          { accessToken: auth.accessToken },
        ).then(res => {
          if (res.customers.length > 0) {
            dispatch(setCloudCustomerSummaries(res.customers));
          }
        });
      }
    } catch (error) {}
  };

  const reloadAppData = useCallback(() => {
    clearAllData();
    setTimeout(() => {
      getCriticalData();
    }, 100);
  }, [getCriticalData]);

  useEffect(() => {
    if (currentLocation) {
      getCriticalData();
      getSettingsFn();
    }
  }, [currentLocation]);

  // Preload product images
  const preloadedUrlsRef = useRef<Set<string>>(new Set());
  useEffect(() => {
    const docs = productDocs || [];
    if (!docs.length) {
      preloadedUrlsRef.current.clear();
      return;
    }
    const urls = docs
      .map((p: any) => String(p?.bp_product_image || '').trim())
      .filter(
        uri => uri && (uri.startsWith('http://') || uri.startsWith('https://')),
      );
    const newUrls: string[] = [];
    for (const url of urls) {
      if (!preloadedUrlsRef.current.has(url)) {
        preloadedUrlsRef.current.add(url);
        newUrls.push(url);
      }
    }
    if (!newUrls.length) return;
    const sources = newUrls.map(uri => ({
      uri: forceHttps(uri),
      cache: FastImage.cacheControl.immutable,
    }));
    FastImage.preload(sources as any);
  }, [productDocs]);

  const handleLocationChange = useCallback(
    (locationId: string) => {
      reloadAppData();
    },
    [reloadAppData],
  );

  const saveUserEmail = async () => {
    if (
      employeedata.bp_employee_email_address &&
      employeedata.bp_employee_email_address?.length > 0
    ) {
      await AsyncStorage.setItem(
        'ElAssist',
        employeedata.bp_employee_email_address,
      );
    }
  };

  useEffect(() => {
    saveUserEmail();
  }, [employeedata.bp_employee_email_address]);

  const confirmBackPress = () => {
    AppAlert.alert(
      'Exit BizPlus POS',
      'Are you sure you want to exit the BizPlus POS app?',
      [
        { text: 'Cancel', onPress: () => null, style: 'cancel' },
        { text: 'Exit', onPress: () => BackHandler.exitApp() },
      ],
    );
    return true;
  };

  useFocusEffect(
    React.useCallback(() => {
      const backHandler = BackHandler.addEventListener(
        'hardwareBackPress',
        confirmBackPress,
      );
      return () => backHandler.remove();
    }, []),
  );

  const clearAll = async () => {
    await dumpTokens();
    setAuth({ accessToken: '', refreshToken: '' });
    dispatch(clearEmployeeAndBusinessInfo());
    dispatch(logoutAction());
  };

  const handleSheetChanges = (index: number) => {
    if (index === -1) bottomSheetHomeModalRef.current?.dismiss();
  };

  const closeModal = () => bottomSheetHomeModalRef.current?.dismiss();

  const handleLogout = async () => {
    if (isLoggingOut) return;
    setIsLoggingOut(true);
    try {
      const refreshToken = await AsyncStorage.getItem('refreshToken');
      await clearAll();
      await axiosprivate.post(
        `bp_employee_log_out_information/${refreshToken}`,
        {},
        { headers: { Authorization: 'Bearer ' + auth.accessToken } },
      );
    } catch (error: any) {
      // Ignore API failure; proceed with local clear
    } finally {
      setIsLoggingOut(false);
      closeModal();
    }
  };

  const handleBarcodeScanner = () =>
    navigation.navigate('ProductScanner' as any);
  const handleAddNewProduct = () => navigation.navigate('NewProduct');
  const handleShopPress = useCallback(
    () =>
      navigation.navigate('MainScreen', {
        screen: 'ProductsScreen',
        params: { from: 'HomeScreen' },
      }),
    [navigation],
  );
  const handleAiChat = () =>
    AppAlert.alert('AI Chat', 'AI Chat assistant feature coming soon!');
  const handleSettings = () => navigation.navigate('SettingsScreen');
  const handleQuickActionsSettings = () =>
    navigation.navigate('QuickActionsSettings' as any);
  const handleServiceDisplay = () =>
    navigation.navigate('ServiceDisplay' as any);

  const handleAddExpenses = useCallback(async () => {
    try {
      let ownerToken = owner?.accessToken as string | undefined | null;
      if (!ownerToken) {
        const loginRes: any = await autoLoginOwner();
        if (loginRes?.status === 'success' && loginRes?.accessToken) {
          ownerToken = String(loginRes.accessToken);
        }
      }
      const ownerId = String((employeedata as any)?.bp_owner_id || '');
      if (!ownerToken || !ownerId) {
        handleError('Missing owner context', 'error', true);
        return;
      }
      dispatch(setExpenseTypesLoading(true));
      dispatch(setExpenseTypesError(null));
      navigation.navigate('BackOfficeExpenseCategories');
      const res = await getExpenseTypes(axiosBackoffice as any, ownerId, {
        accessToken: ownerToken,
      });
      if (res?.status === 200) {
        const items = res?.data?.data as any[];
        dispatch(setExpenseTypes(items));
      } else {
        dispatch(
          setExpenseTypesError(
            String(res?.data?.message || 'Failed to load expense types'),
          ),
        );
      }
    } catch (e: any) {
      dispatch(
        setExpenseTypesError(e?.message || 'Error fetching expense types'),
      );
    } finally {
      dispatch(setExpenseTypesLoading(false));
    }
  }, [
    owner?.accessToken,
    autoLoginOwner,
    employeedata,
    axiosBackoffice,
    dispatch,
    handleError,
    navigation,
  ]);

  const handleAddSupplier = useCallback(() => {
    navigation.navigate('BackOfficeAddSupplier');
  }, [navigation]);

  const handleAddStaff = useCallback(() => {
    navigation.navigate('BackOfficeAddEmployee');
  }, [navigation]);

  const handleNavigateToEmployeeSelfie = () => {
    bottomSheetHomeModalRef.current?.dismiss();
    navigation.navigate('EmployeeSelfie');
  };

  const handleCreatePurchaseOrder = useCallback(() => {
    navigation.navigate('BackOfficePurchaseOrderUpsert');
  }, [navigation]);

  const handleCreateGoodsReceiptEntry = useCallback(() => {
    navigation.navigate('BackOfficeCreateGoodsReceipt');
  }, [navigation]);

  // Data-driven Quick Actions
  const quickActions = useMemo(
    () => [
      {
        key: 'add',
        label: 'Add Items',
        visible: Boolean(isAdmin),
        children: [
          {
            key: 'expenses',
            label: 'Expense',
            color: colors.secondaryDark,
            onPress: handleAddExpenses,
            renderIcon: (tint?: string) => (
              <MaterialCommunityIcons
                name="cash-plus"
                size={iconSize(24)}
                color={tint || colors.text}
              />
            ),
          },
          {
            key: 'products',
            label: 'Product',
            color: colors.successDark,
            onPress: handleAddNewProduct,
            renderIcon: (tint?: string) => (
              <MaterialCommunityIcons
                name="package-variant-closed"
                size={iconSize(24)}
                color={tint || colors.text}
              />
            ),
          },
          {
            key: 'supplier',
            label: 'Supplier',
            color: colors.primaryDark,
            onPress: handleAddSupplier,
            renderIcon: (tint?: string) => (
              <MaterialCommunityIcons
                name="truck-delivery-outline"
                size={iconSize(24)}
                color={tint || colors.text}
              />
            ),
          },
          {
            key: 'staff',
            label: 'Staff',
            color: colors.premium,
            onPress: handleAddStaff,
            renderIcon: (tint?: string) => (
              <MaterialCommunityIcons
                name="account-multiple-plus-outline"
                size={iconSize(24)}
                color={tint || colors.text}
              />
            ),
          },
        ],
      },
      {
        key: 'create',
        label: 'Buy & Receive',
        visible: Boolean(isAdmin),
        children: [
          {
            key: 'purchaseOrder',
            label: 'Purchase Order',
            color: colors.successDark,
            onPress: handleCreatePurchaseOrder,
            renderIcon: (tint?: string) => (
              <MaterialCommunityIcons
                name="clipboard-text-outline"
                size={iconSize(24)}
                color={tint || colors.text}
              />
            ),
          },
          {
            key: 'goodsReceipt',
            label: 'Goods Receipt',
            color: colors.primaryDark,
            onPress: handleCreateGoodsReceiptEntry,
            renderIcon: (tint?: string) => (
              <LucideIcon
                name="archive-restore"
                size={iconSize(22)}
                color={tint || colors.text}
              />
            ),
          },
        ],
      },
      {
        key: 'notes',
        label: 'Quick Notes',
        color: colors.warningDark,
        visible: true,
        onPress: () => navigation.navigate('Notes'),
        renderIcon: (tint?: string) => (
          <MaterialCommunityIcons
            name="note-text-outline"
            size={iconSize(24)}
            color={tint || colors.text}
          />
        ),
      },
      {
        key: 'scanner',
        label: 'Scan to Sell',
        color: colors.successDark,
        visible: true,
        onPress: handleBarcodeScanner,
        renderIcon: (tint?: string) => (
          <MaterialCommunityIcons
            name="barcode-scan"
            size={iconSize(26)}
            color={tint || colors.text}
          />
        ),
      },
      {
        key: 'calculator',
        label: 'Calculator',
        color: colors.primaryDark,
        visible: true,
        onPress: () => navigation.navigate('Calculator'),
        renderIcon: (tint?: string) => (
          <MaterialCommunityIcons
            name="calculator-variant-outline"
            size={iconSize(24)}
            color={tint || colors.text}
          />
        ),
      },
      {
        key: 'serviceDisplay',
        label: orderDisplayMeta.label,
        color: colors.infoDark,
        visible: true,
        onPress: handleServiceDisplay,
        renderIcon: (tint?: string) => (
          <MaterialCommunityIcons
            name={orderDisplayMeta.icon}
            size={iconSize(24)}
            color={tint || colors.text}
          />
        ),
      },
      {
        key: 'aiAssistant',
        label: 'Rafiki AI Assistant',
        color: colors.premiumDark,
        visible: true,
        onPress: handleAiChat,
        renderIcon: (tint?: string) => (
          <MaterialCommunityIcons
            name="robot-outline"
            size={iconSize(24)}
            color={tint || colors.text}
          />
        ),
      },
    ],
    [
      colors,
      isAdmin,
      orderDisplayMeta,
      navigation,
      handleAddExpenses,
      handleAddSupplier,
      handleAddStaff,
      handleCreatePurchaseOrder,
      handleCreateGoodsReceiptEntry,
    ],
  );

  const sortedActions = useMemo(() => {
    let visible = quickActions.filter(
      action => action.visible && enabledQuickActions?.includes(action.key),
    );
    if (showservicedisplay) {
      const allowedActions = [
        'aiAssistant',
        'notes',
        'serviceDisplay',
        'calculator',
      ];
      visible = visible.filter(action => allowedActions.includes(action.key));
    }
    if (visible.length > 0) {
      return [...visible].sort(
        (a, b) =>
          quickActionOrder?.indexOf(a.key) - quickActionOrder?.indexOf(b.key),
      );
    }
    return [];
  }, [enabledQuickActions, quickActionOrder, showservicedisplay, quickActions]);

  const quickSegments = useMemo(
    () => buildQuickActionSegments(sortedActions),
    [sortedActions],
  );
  /** A lone segment is just a flat grid — the track would have nothing to switch. */
  const showQuickSegments = quickSegments.length > 1;
  const activeQuickSegment = Math.min(
    selectedQuickSegment,
    Math.max(quickSegments.length - 1, 0),
  );
  const quickTiles = quickSegments[activeQuickSegment]?.tiles ?? [];

  // Get first name properly formatted
  const firstName = useMemo(() => {
    const name = employeedata?.bp_employee_name || '';
    const first = name.split(' ')[0] || '';
    return first.charAt(0).toUpperCase() + first.slice(1).toLowerCase();
  }, [employeedata?.bp_employee_name]);

  // Responsive layout calculations
  const isLargeScreen = width >= 1024;
  const isMediumScreen = width >= 768;

  return (
    <View style={styles.container}>
      {/* Post-wizard celebration modal — self-guarded; no-op unless the
          persisted pending flag is set for this owner. */}
      <WizardHomeCelebrationController />
      <ScrollView
        ref={scrollViewRef}
        style={styles.scrollView}
        contentContainerStyle={styles.scrollContent}
        showsVerticalScrollIndicator={false}>
        {/* Hero Section */}
        <View style={styles.heroSection}>
          <View style={styles.heroContent}>
            <Text style={styles.greeting}>
              {getTimeBasedGreeting()},{' '}
              <Text style={styles.greetingName}>{firstName}.</Text>
            </Text>
            {/* <Text style={styles.subtitle}>What would you like to do today?</Text> */}
          </View>
        </View>

        {/* Main Actions Grid */}
        <View style={styles.mainContent}>
          {showservicedisplay ? (
            <View style={styles.singleCardContainer}>
              <AnimatedCard
                onPress={handleServiceDisplay}
                disabled={isLocationSwitching}
                style={[
                  styles.primaryCard,
                  styles.serviceCard,
                  isLocationSwitching && { opacity: 0.5 },
                ]}>
                <View style={styles.cardInner}>
                  {(() => {
                    const iconStyles = getIconContainerStyle(
                      theme.colors.primary,
                      iconStyle,
                    );
                    return (
                      <View
                        style={[
                          styles.cardIconContainer,
                          { backgroundColor: iconStyles.backgroundColor },
                        ]}>
                        <MaterialCommunityIcons
                          name={orderDisplayMeta.icon}
                          color={iconStyles.iconColor}
                          size={iconSize(40)}
                        />
                      </View>
                    );
                  })()}
                  <View style={styles.cardTextContainer}>
                    <Text style={styles.cardTitle}>
                      {orderDisplayMeta.label}
                    </Text>
                    <Text style={styles.cardSubtitle}>
                      View and prepare orders
                    </Text>
                  </View>
                  <View style={styles.cardArrow}>
                    <Feather
                      name="arrow-right"
                      size={iconSize(24)}
                      color={colors.textSecondary}
                    />
                  </View>
                </View>
              </AnimatedCard>
            </View>
          ) : (
            <View
              style={[
                styles.cardsGrid,
                isLargeScreen && styles.cardsGridLarge,
              ]}>
              {/* Shop Card */}
              <AnimatedCard
                onPress={handleShopPress}
                disabled={isLocationSwitching}
                variant="primary"
                style={[
                  styles.primaryCard,
                  isAdmin ? null : styles.primaryCardGreen,
                  isLargeScreen
                    ? styles.primaryCardLarge
                    : styles.primaryCardMedium,
                  isLocationSwitching && { opacity: 0.5 },
                ]}>
                <View
                  style={
                    isAdmin
                      ? styles.cardGradientOrange
                      : styles.cardGradientGreen
                  }>
                  {/* Decorative pattern overlay */}
                  <View
                    style={
                      isAdmin ? styles.cardPattern : styles.cardPatternGreen
                    }
                  />
                  <View style={styles.cardInnerPrimary}>
                    {(() => {
                      const iconStyles = getIconContainerStyle(
                        isAdmin
                          ? theme.colors.secondary
                          : colors.successEmerald,
                        iconStyle,
                      );
                      return (
                        <View
                          style={
                            isAdmin
                              ? styles.primaryIconContainer
                              : styles.primaryIconContainerGreen
                          }>
                          <FontAwesome
                            name={shopActionMeta.icon as any}
                            iconStyle="solid"
                            color={colors.textInverse}
                            size={iconSize(28)}
                          />
                        </View>
                      );
                    })()}
                    <View style={styles.cardTextSection}>
                      <Text style={styles.primaryCardTitle}>
                        {shopActionMeta.title}
                      </Text>
                      <Text style={styles.primaryCardSubtitle}>
                        {shopActionMeta.subtitle}
                      </Text>
                    </View>
                    <View
                      style={
                        isAdmin
                          ? styles.cardActionButton
                          : styles.cardActionButtonGreen
                      }>
                      <Text
                        style={
                          isAdmin
                            ? styles.cardActionText
                            : styles.cardActionTextGreen
                        }>
                        {!todayDashLoading &&
                        (todayDashData?.totalOrders ?? 0) === 0
                          ? 'First Sale'
                          : 'New Sale'}
                      </Text>
                      <View
                        style={
                          isAdmin
                            ? styles.cardActionArrow
                            : styles.cardActionArrowGreen
                        }>
                        <Feather
                          name="arrow-right"
                          size={iconSize(16)}
                          color={
                            isAdmin ? colors.secondary : colors.successEmerald
                          }
                        />
                      </View>
                    </View>
                  </View>
                </View>
              </AnimatedCard>

              {/* Back Office / Orders Card */}
              {isAdmin ? (
                <AnimatedCard
                  onPress={handleBackOfficePress}
                  disabled={isLocationSwitching}
                  variant="secondary"
                  style={[
                    styles.primaryCard,
                    styles.primaryCardGreen,
                    isLargeScreen
                      ? styles.primaryCardLarge
                      : styles.primaryCardMedium,
                    isLocationSwitching && { opacity: 0.5 },
                  ]}>
                  <View style={styles.cardGradientGreen}>
                    {/* Decorative pattern overlay */}
                    <View style={styles.cardPatternGreen} />
                    <View style={styles.cardInnerPrimary}>
                      {(() => {
                        // const iconStyles = getIconContainerStyle(
                        //   colors.successDark,
                        //   iconStyle,
                        // );
                        return (
                          <View style={styles.primaryIconContainerGreen}>
                            <Foundation
                              name="dollar"
                              size={iconSize(40)}
                              color={colors.textInverse}
                            />
                          </View>
                        );
                      })()}
                      <View style={styles.cardTextSection}>
                        <Text style={styles.primaryCardTitle}>BACK OFFICE</Text>
                        <Text style={styles.primaryCardSubtitle}>
                          Manage Business
                        </Text>
                      </View>
                      <View style={styles.cardActionButtonGreen}>
                        <Text style={styles.cardActionTextGreen}>
                          View dashboard
                        </Text>
                        <View style={styles.cardActionArrowGreen}>
                          <Feather
                            name="arrow-right"
                            size={iconSize(16)}
                            color={colors.successEmerald}
                          />
                        </View>
                      </View>
                    </View>
                  </View>
                </AnimatedCard>
              ) : (
                <AnimatedCard
                  onPress={() => navigation.navigate('Orders')}
                  disabled={isLocationSwitching}
                  variant="secondary"
                  style={[
                    styles.primaryCard,
                    styles.primaryCardBlue,
                    isLargeScreen
                      ? styles.primaryCardLarge
                      : styles.primaryCardMedium,
                    isLocationSwitching && { opacity: 0.5 },
                  ]}>
                  <View style={styles.cardGradientBlue}>
                    {/* Decorative pattern overlay */}
                    <View style={styles.cardPatternBlue} />
                    <View style={styles.cardInnerPrimary}>
                      {(() => {
                        const iconStyles = getIconContainerStyle(
                          colors.infoDark,
                          iconStyle,
                        );
                        return (
                          <View style={styles.primaryIconContainerBlue}>
                            <MaterialCommunityIcons
                              name="clipboard-list"
                              size={iconSize(28)}
                              color={colors.textInverse}
                            />
                          </View>
                        );
                      })()}
                      <View style={styles.cardTextSection}>
                        <Text style={styles.primaryCardTitle}>ORDERS</Text>
                        <Text style={styles.primaryCardSubtitle}>
                          Manage Orders
                        </Text>
                      </View>
                      <View style={styles.cardActionButtonBlue}>
                        <Text style={styles.cardActionTextBlue}>
                          View orders
                        </Text>
                        <View style={styles.cardActionArrowBlue}>
                          <Feather
                            name="arrow-right"
                            size={iconSize(16)}
                            color={colors.infoAlt}
                          />
                        </View>
                      </View>
                    </View>
                  </View>
                </AnimatedCard>
              )}
            </View>
          )}

          {/* Quick Tools Section (owner: replaced by activation tracker while
              the setup flow is active) */}
          {(() => {
            const quickToolsSection = (
              <View style={styles.quickToolsSection}>
                <View style={styles.quickToolsHeader}>
                  <Text style={styles.sectionTitle}>Quick Tools</Text>
                  <Pressable
                    onPress={handleQuickActionsSettings}
                    style={({ pressed, hovered }: any) => [
                      styles.editButton,
                      hovered && { opacity: 0.7 },
                      pressed && { opacity: 0.7 },
                    ]}>
                    <Text style={styles.editText}>Edit</Text>
                    <MaterialIcons
                      name="chevron-right"
                      size={iconSize(18)}
                      color={colors.primary}
                    />
                  </Pressable>
                </View>

                {showQuickSegments ? (
                  <View style={styles.quickSegmentsRow}>
                    <QuickActionSegments
                      segments={quickSegments}
                      activeIndex={activeQuickSegment}
                      onChange={setSelectedQuickSegment}
                      disabled={isLocationSwitching}
                      colors={colors}
                      colorMode={quickActionColorMode}
                    />
                  </View>
                ) : null}

                <View
                  style={[
                    styles.quickToolsGrid,
                    isLargeScreen && styles.quickToolsGridLarge,
                  ]}>
                  {quickTiles.map(action => {
                    const isFilled = iconStyle === 'filled';
                    const iconStyles =
                      quickActionColorMode === 'colored'
                        ? getIconContainerStyle(action.color, iconStyle)
                        : {
                            backgroundColor: isFilled
                              ? colors.neutralTileIcon
                              : colors.neutralTileBg,
                            borderColor: colors.neutralTileBg,
                            iconColor: isFilled
                              ? colors.textInverse
                              : colors.neutralTileIcon,
                          };
                    return (
                      <QuickActionButton
                        key={action.key}
                        action={action}
                        iconStyles={iconStyles}
                        isLocationSwitching={isLocationSwitching}
                        styles={styles}
                      />
                    );
                  })}
                </View>
              </View>
            );

            if (
              !isAdmin ||
              !isEmployeeOwnerRole(employeedata?.bp_employee_role)
            ) {
              return quickToolsSection;
            }

            return (
              <OwnerGuidanceSlot
                renderQuickActions={() => quickToolsSection}
                renderTracker={() => (
                  <View style={styles.quickToolsSection}>
                    <OwnerActivationTrackerContainer
                      isLocationSwitching={isLocationSwitching}
                      openBackOffice={handleBackOfficePress}
                      openAddStaff={handleAddStaff}
                      openLocationPicker={handleOpenLocationPicker}
                    />
                    <OwnerActivationCelebrationController />
                  </View>
                )}
              />
            );
          })()}

          {/* Recent Transactions - only when not service display */}
          {!showservicedisplay && (
            <RecentTransactionsSection
              transactions={
                isAdmin
                  ? recentTransactionsState.recent.docs || []
                  : employeeRecentTransactionsState.recent.docs || []
              }
              loading={
                isAdmin
                  ? recentTransactionsState.loading
                  : employeeRecentTransactionsState.loading
              }
              error={
                isAdmin
                  ? recentTransactionsState.error
                  : employeeRecentTransactionsState.error
              }
              hasNextPage={
                isAdmin
                  ? recentTransactionsState.recent.hasNextPage
                  : employeeRecentTransactionsState.recent.hasNextPage
              }
              onLoadMore={
                isAdmin
                  ? handleLoadMoreOwnerRecent
                  : handleLoadMoreEmployeeRecent
              }
              onPressTransaction={handleOpenRecentTransaction}
              onPressViewAll={handleOrdersPress}
              currencyCode={currency}
              interactionDisabled={isLocationSwitching}
            />
          )}
        </View>
      </ScrollView>

      {/* Bottom Sheet Modal */}
      <CustomBottomSheet
        bottomSheetModalRef={bottomSheetHomeModalRef}
        snapPoints={['42%']}
        enableDynamicSizing={false}
        handleSheetChanges={handleSheetChanges}
        footer={
          <TouchableOpacity
            style={[
              styles.logoutButton,
              isLoggingOut && styles.logoutButtonPressed,
            ]}
            onPress={handleLogout}
            disabled={isLoggingOut}>
            {isLoggingOut ? (
              <ActivityIndicator size="small" color={colors.textInverse} />
            ) : (
              <FontAwesome
                name="power-off"
                iconStyle="solid"
                size={iconSize(20)}
                color={colors.error}
              />
            )}
            <Text
              style={[
                styles.logoutText,
                isLoggingOut && styles.logoutTextPressed,
              ]}>
              {isLoggingOut ? 'Logging out...' : 'Logout'}
            </Text>
          </TouchableOpacity>
        }>
        <View style={styles.bottomSheetContent}>
          <View style={styles.userDetailsContainer}>
            <Text style={styles.businessTitle}>{business.name}</Text>
            <View style={styles.userDetailsRow}>
              <View style={styles.profileImageContainer}>
                {(() => {
                  const preferred =
                    employeedata?.bp_employee_profile_picture_url ||
                    employeedata?.bp_employee_profile_picture_local_uri ||
                    'https://w7.pngwing.com/pngs/831/88/png-transparent-user-profile-computer-icons-user-interface-mystique-miscellaneous-user-interface-design-smile-thumbnail.png';
                  const uri = preferred?.startsWith('http')
                    ? forceHttps(preferred)
                    : preferred;
                  return (
                    <SecureImage uri={uri} style={styles.userProfilePicture} />
                  );
                })()}
                <TouchableOpacity
                  onPress={handleNavigateToEmployeeSelfie}
                  style={styles.cameraButton}>
                  <MaterialIcons
                    name="photo-camera"
                    size={iconSize(16)}
                    color={colors.textInverse}
                  />
                </TouchableOpacity>
              </View>
              <View style={styles.userInfoContainer}>
                <View style={styles.userInfoRow}>
                  <Text style={styles.userInfoLabel}>Name:</Text>
                  <Text style={styles.userInfoValue}>
                    {employeedata?.bp_employee_name}
                  </Text>
                </View>
                <View style={styles.userInfoRow}>
                  <Text style={styles.userInfoLabel}>Role:</Text>
                  <Text style={styles.userInfoValue}>
                    {employeedata?.bp_employee_role}
                  </Text>
                </View>
                <View style={styles.userInfoRow}>
                  <Text style={styles.userInfoLabel}>Phone:</Text>
                  <Text style={styles.userInfoValue}>
                    {employeedata?.bp_employee_phone_number}
                  </Text>
                </View>
              </View>
            </View>

            <View style={styles.footerInfo}>
              <Text style={styles.footerText}>
                Thank you for using BizPlus POS
              </Text>
              <Text style={styles.versionText}>
                {appVersion ? `v ${appVersion}` : 'v'}
              </Text>
            </View>
          </View>
        </View>
      </CustomBottomSheet>
    </View>
  );
};

export default HomeScreen;

const createStyles = (theme: any, screenWidth: number) => {
  const isLarge = screenWidth >= 1024;
  const isMedium = screenWidth >= 768;
  const sizeClass = getSizeClass(screenWidth);
  const isExpanded =
    sizeClass === 'expanded' ||
    sizeClass === 'large' ||
    sizeClass === 'extraLarge';
  const colors = theme.colors;
  const whiteWithOpacity = (opacity: number) =>
    withOpacity(colors.textInverse, opacity);
  return StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.backgroundGray50,
    },
    scrollView: {
      flex: 1,
    },
    scrollContent: {
      paddingBottom: v(20),
    },

    // Hero Section
    heroSection: {
      paddingHorizontal: s(isLarge ? 48 : isMedium ? 32 : 20),
      paddingTop: v(14),
      paddingBottom: v(16),
    },
    heroContent: {},
    greeting: {
      fontSize: fs(isLarge ? 24 : isMedium ? 24 : 20),
      lineHeight: fs(isLarge ? 28 : isMedium ? 28 : 24),
      color: theme.colors.textGray600,
      fontFamily: GTFonts.regular,
      marginBottom: v(4),
      letterSpacing: fs(-1),
    },
    greetingName: {
      fontSize: fs(isLarge ? 24 : isMedium ? 24 : 20),
      lineHeight: fs(isLarge ? 28 : isMedium ? 28 : 24),
      fontFamily: GTFonts.semibold,
      color: colors.textGray900,
      letterSpacing: fs(-0.5),
    },
    subtitle: {
      fontSize: fs(isLarge ? 18 : 16),
      fontFamily: GTFonts.regular,
      color: colors.textGray500,
      letterSpacing: fs(0.2),
    },

    // Main Content
    mainContent: {
      paddingHorizontal: s(isLarge ? 48 : isMedium ? 32 : 20),
    },

    // Cards Grid
    cardsGrid: {
      flexDirection: isMedium ? 'row' : 'column',
      gap: s(20),
    },
    cardsGridLarge: {
      gap: s(24),
    },

    // Primary Cards
    primaryCard: {
      flex: 1,
      borderRadius: s(24),
      overflow: 'hidden',
      minHeight: v(isLarge ? 220 : isMedium ? 200 : 180),
      boxShadow: `0px ${v(4)}px ${s(12)}px rgba(0, 0, 0, 0.08)`,
      backgroundColor: colors.secondary,
      marginBottom: v(16),
    } as any,
    primaryCardLarge: {
      minHeight: v(270),
    },
    primaryCardMedium: {
      minHeight: v(260),
    },
    primaryCardGreen: {
      backgroundColor: colors.successEmerald,
    },
    primaryCardBlue: {
      backgroundColor: colors.infoAlt,
    },
    cardGradientOrange: {
      flex: 1,
      backgroundColor: colors.secondary,
      padding: s(isLarge ? 20 : 18),
      position: 'relative',
    },
    cardGradientGreen: {
      flex: 1,
      backgroundColor: colors.successEmerald,
      padding: s(isLarge ? 20 : 18),
      position: 'relative',
    },
    cardGradientBlue: {
      flex: 1,
      backgroundColor: colors.infoAlt,
      padding: s(isLarge ? 20 : 18),
      position: 'relative',
    },
    // Decorative patterns
    cardPattern: {
      position: 'absolute',
      top: v(-60),
      right: s(-60),
      width: s(200),
      height: v(200),
      borderRadius: s(100),
      backgroundColor: whiteWithOpacity(0.08),
    },
    cardPatternGreen: {
      position: 'absolute',
      top: v(-60),
      right: s(-60),
      width: s(200),
      height: v(200),
      borderRadius: s(100),
      backgroundColor: whiteWithOpacity(0.08),
    },
    cardPatternBlue: {
      position: 'absolute',
      top: v(-60),
      right: s(-60),
      width: s(200),
      height: v(200),
      borderRadius: s(100),
      backgroundColor: whiteWithOpacity(0.08),
    },
    cardInnerPrimary: {
      flex: 1,
      justifyContent: 'space-between',
      zIndex: 1,
    },
    primaryIconContainer: {
      width: iconSize(56),
      height: iconSize(56),
      borderRadius: theme.borderRadius.lg,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: whiteWithOpacity(0.2),
      borderWidth: borderWidth(1),
      borderColor: whiteWithOpacity(0.3),
      marginBottom: v(20),
    },
    primaryIconContainerGreen: {
      width: iconSize(56),
      height: iconSize(56),
      borderRadius: theme.borderRadius.lg,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: whiteWithOpacity(0.2),
      borderWidth: borderWidth(1),
      borderColor: whiteWithOpacity(0.3),
      marginBottom: v(20),
    },
    primaryIconContainerBlue: {
      width: iconSize(56),
      height: iconSize(56),
      borderRadius: theme.borderRadius.lg,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: whiteWithOpacity(0.2),
      borderWidth: borderWidth(1),
      borderColor: whiteWithOpacity(0.3),
      marginBottom: v(20),
    },
    cardTextSection: {
      flex: 1,
      justifyContent: 'center',
    },
    primaryCardTitle: {
      fontSize: fs(isLarge ? 22 : 20),
      fontFamily: GTFonts.bold,
      color: colors.textInverse,
      letterSpacing: fs(0.5),
      marginTop: v(12),
      marginBottom: v(12),
    },
    primaryCardSubtitle: {
      fontSize: fs(15),
      fontFamily: GTFonts.regular,
      color: whiteWithOpacity(0.8),
      marginBottom: v(8),
    },
    // Action buttons
    cardActionButton: {
      flexDirection: 'row',
      alignItems: 'center',
      alignSelf: 'flex-start',
      backgroundColor: colors.surface,
      paddingHorizontal: s(16),
      paddingVertical: v(10),
      borderRadius: s(12),
      gap: s(10),
      marginTop: v(20),
    },
    cardActionButtonGreen: {
      flexDirection: 'row',
      alignItems: 'center',
      alignSelf: 'flex-start',
      backgroundColor: colors.surface,
      paddingHorizontal: s(16),
      paddingVertical: v(10),
      borderRadius: s(12),
      gap: s(10),
      marginTop: v(20),
    },
    cardActionButtonBlue: {
      flexDirection: 'row',
      alignItems: 'center',
      alignSelf: 'flex-start',
      backgroundColor: colors.surface,
      paddingHorizontal: s(16),
      paddingVertical: v(10),
      borderRadius: s(12),
      gap: s(10),
      marginTop: v(20),
    },
    cardActionText: {
      fontSize: fs(14),
      lineHeight: fs(16),
      fontFamily: GTFonts.semibold,
      color: colors.secondary,
    },
    cardActionTextGreen: {
      fontSize: fs(14),
      fontFamily: GTFonts.semibold,
      color: colors.successEmerald,
    },
    cardActionTextBlue: {
      fontSize: fs(14),
      fontFamily: GTFonts.semibold,
      color: colors.infoAlt,
    },
    cardActionArrow: {
      width: iconSize(24),
      height: iconSize(24),
      borderRadius: s(12),
      backgroundColor: withOpacity(colors.secondary, 0.1),
      alignItems: 'center',
      justifyContent: 'center',
    },
    cardActionArrowGreen: {
      width: iconSize(24),
      height: iconSize(24),
      borderRadius: s(12),
      backgroundColor: withOpacity(colors.successEmerald, 0.1),
      alignItems: 'center',
      justifyContent: 'center',
    },
    cardActionArrowBlue: {
      width: iconSize(24),
      height: iconSize(24),
      borderRadius: s(12),
      backgroundColor: withOpacity(colors.infoAlt, 0.1),
      alignItems: 'center',
      justifyContent: 'center',
    },

    // Service Display Single Card
    singleCardContainer: {
      marginBottom: v(32),
    },
    serviceCard: {
      backgroundColor: colors.surface,
      minHeight: v(100),
    },
    cardInner: {
      flexDirection: 'row',
      alignItems: 'center',
      padding: s(24),
      gap: s(20),
    },
    cardIconContainer: {
      width: iconSize(72),
      height: iconSize(72),
      borderRadius: s(18),
      alignItems: 'center',
      justifyContent: 'center',
    },
    cardTextContainer: {
      flex: 1,
    },
    cardTitle: {
      fontSize: fs(20),
      fontFamily: GTFonts.bold,
      color: colors.textGray900,
      marginBottom: v(4),
    },
    cardSubtitle: {
      fontSize: fs(14),
      lineHeight: fs(18),
      fontFamily: GTFonts.regular,
      color: colors.textGray500,
    },
    cardArrow: {
      padding: s(8),
    },

    // Quick Tools Section
    quickToolsSection: {
      backgroundColor: colors.surface,
      borderRadius: s(20),
      paddingHorizontal: s(isLarge ? 28 : 24),
      paddingVertical: v(isLarge ? 10 : 12),
      boxShadow: `0px ${v(2)}px ${s(8)}px rgba(0, 0, 0, 0.04)`,
    } as any,
    quickToolsHeader: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: v(isLarge ? 14 : 12),
    },
    sectionTitle: {
      fontSize: fs(isLarge ? 20 : 18),
      fontFamily: GTFonts.semibold,
      color: colors.textGray900,
    },
    editButton: {
      paddingVertical: v(5),
      flexDirection: 'row',
      alignItems: 'center',
      gap: s(2),
    },
    editText: {
      fontSize: fs(12),
      fontFamily: GTFonts.semibold,
      lineHeight: fs(14),
      color: colors.primary,
    },
    quickSegmentsRow: {
      marginBottom: v(isLarge ? 14 : 12),
    },

    quickToolsGrid: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: s(12),
      justifyContent: isExpanded ? 'space-evenly' : 'flex-start',
      marginBottom: v(isLarge ? 4 : 8),
    },
    quickToolsGridLarge: {
      gap: s(16),
    },

    quickActionItem: {
      alignItems: 'center',
      paddingHorizontal: s(isLarge ? 18 : 16),
      paddingVertical: v(isLarge ? 14 : 14),
      borderRadius: s(16),
      backgroundColor: colors.surface,
      borderWidth: StyleSheet.hairlineWidth,
      borderColor: colors.borderGray200,
      ...(isExpanded
        ? { minWidth: s(isLarge ? 140 : isTablet() ? 200 : 88), flexShrink: 0 }
        : {
            width: s(isLarge ? 164 : isTablet() ? 200 : 88),
            minWidth: s(isLarge ? 164 : isTablet() ? 200 : 88),
            maxWidth: s(isLarge ? 164 : isTablet() ? 200 : 88),
          }),
    },
    quickActionItemHovered: {
      backgroundColor: colors.backgroundGray50Alt,
      borderWidth: borderWidth(1),
    },
    quickActionIcon: {
      width: iconSize(isLarge ? 48 : 52),
      height: iconSize(isLarge ? 48 : 52),
      borderRadius: s(14),
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: v(isLarge ? 10 : 12),
    },
    quickActionText: {
      fontSize: fs(isLarge ? 15 : 14),
      fontFamily: GTFonts.semibold,
      color: colors.textGray900,
      textAlign: 'center',
      lineHeight: fs(isLarge ? 18 : 16),
    },
    quickActionTextHovered: {
      color: colors.textGray600,
    },

    // Bottom Sheet Styles
    bottomSheetContent: {
      flex: 1,
      alignItems: 'center',
      paddingHorizontal: s(24),
    },
    userDetailsContainer: {
      width: '100%',
      maxWidth: s(400),
    },
    businessTitle: {
      fontSize: fs(22),
      fontFamily: GTFonts.bold,
      color: colors.textGray900,
      textAlign: 'center',
      textTransform: 'uppercase',
      marginBottom: v(24),
    },
    userDetailsRow: {
      flexDirection: 'row',
      gap: s(20),
      alignItems: 'flex-start',
    },
    profileImageContainer: {
      position: 'relative',
    },
    userProfilePicture: {
      width: iconSize(72),
      height: iconSize(72),
      borderRadius: s(36),
    },
    cameraButton: {
      position: 'absolute',
      right: 0,
      bottom: 0,
      backgroundColor: colors.textGray500,
      borderRadius: theme.borderRadius.lg,
      padding: s(6),
      borderWidth: borderWidth(2),
      borderColor: colors.surface,
    },
    userInfoContainer: {
      flex: 1,
      gap: s(8),
    },
    userInfoRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: s(8),
    },
    userInfoLabel: {
      fontSize: fs(16),
      fontFamily: GTFonts.bold,
      color: colors.textGray700,
    },
    userInfoValue: {
      fontSize: fs(16),
      fontFamily: GTFonts.regular,
      color: colors.textGray600,
    },

    logoutButton: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: s(10),
      marginTop: v(28),
      paddingVertical: v(14),
      borderRadius: s(12),
      borderWidth: borderWidth(2),
      borderColor: colors.error,
      backgroundColor: colors.surface,
    },
    logoutButtonPressed: {
      backgroundColor: colors.error,
    },
    logoutText: {
      fontSize: fs(18),
      fontFamily: GTFonts.semibold,
      color: colors.error,
    },
    logoutTextPressed: {
      color: colors.textInverse,
    },

    footerInfo: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: s(12),
      marginTop: v(28),
    },
    footerText: {
      fontSize: fs(14),
      fontFamily: GTFonts.regular,
      color: colors.textGray500,
    },
    versionText: {
      fontSize: fs(14),
      fontFamily: GTFonts.regular,
      color: colors.primary,
      textDecorationLine: 'underline',
    },
  });
};
